import * as types from '../../index';

export const aflt_departmentsListAction = (data) => {
    return {
    type: types.DEPARTMENT_LIST_AFFILIATE,
    data
    }
};

export const aflt_departmentAddAction = (data) => {
    return {
    type: types.DEPARTMENT_ADD_AFFILIATE,
    data
    }
};

export const aflt_departmentUpdateAction = (data) => {
    return {
    type: types.DEPARTMENT_UPDATE_AFFILIATE,
    data
    }
};

export const aflt_departmentDeleteAction = (data) => {
    return {
    type: types.DEPARTMENT_DELETE_AFFILIATE,
    data
    }
};
